import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["avatarSrc", "title", "titleInfo"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import TAGTypography from '../TAGTypography/TAGTypography';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';
import { ICON_SIZES } from '../../../constants/constant';

var TAGNavHeaderContent = function TAGNavHeaderContent(_ref) {
  var avatarSrc = _ref.avatarSrc,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Title' : _ref$title,
      _ref$titleInfo = _ref.titleInfo,
      titleInfo = _ref$titleInfo === void 0 ? '' : _ref$titleInfo,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleClick = function handleClick() {
    setOpen(!open);
  };

  return React.createElement(List, _objectSpread({
    sx: {
      width: '100%'
    }
  }, props), avatarSrc && React.createElement(ListItem, null, React.createElement(ListItemAvatar, null, React.createElement(Avatar, {
    src: avatarSrc
  }))), React.createElement(ListItemButton, {
    onClick: handleClick,
    "data-test": "openButton"
  }, React.createElement(ListItemText, {
    primary: React.createElement(TAGTypography, {
      variant: "bodyLargeBold"
    }, title)
  }), titleInfo && (open ? React.createElement(TAGSvgIcon, {
    icon: "SortUp",
    size: ICON_SIZES.md,
    color: 'text.link',
    "data-test": "openIcon"
  }) : React.createElement(TAGSvgIcon, {
    icon: "SortDown",
    size: ICON_SIZES.md,
    color: 'text.link',
    "data-test": "closeIcon"
  }))), titleInfo && React.createElement(Collapse, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, React.createElement(List, {
    component: "div",
    disablePadding: true
  }, React.createElement(ListItemButton, {
    sx: {
      pl: 4
    }
  }, React.createElement(ListItemText, {
    primary: React.createElement(TAGTypography, {
      variant: "bodySmallBook"
    }, titleInfo)
  })))));
};

export default TAGNavHeaderContent;